"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var dealers_1 = require("../graphql/queries/dealers");
var useErrorHandler_1 = require("../../../common/hooks/useErrorHandler");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
exports.useDealers = function () {
    var _a;
    var deal = useCheckoutContext_1.default().deal;
    var postCode = (((_a = deal) === null || _a === void 0 ? void 0 : _a.dealer) || {}).postCode;
    var _b = client_1.useQuery(dealers_1.default.GET_DEALERS, {
        variables: {
            postCode: postCode,
        },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    useErrorHandler_1.default(error);
    return { loading: loading, data: data, error: error };
};
